import { type ModelFilterLabelType, modelFilterLabels } from "../../utils/labels";
import { type ModelFilterSettingsActionsType, MODEL_FILTER_SETTINGS_INIT } from "../actions/ModelFilterSettingsActions";
import type { NewCarFuelTypeFilterId } from "../../../../../common-deprecated/constants";
import type {
    ModelFilterComingSoonBlockConfigType,
    ModelFilterPromotioBannerConfigType,
} from "../../server/AEMModelFilterSettingsTypes";
import type { NcPageUrlsModelDataType } from "../../../../../common-deprecated/utils/aemPageUrlTypes";

export type ModelFilterSettingsType = {
    initialized: boolean;
    fuelTypeSortOrder: NewCarFuelTypeFilterId[];
    newCarDisableMonthlySort: boolean;
    comingSoonBlockConfigurations?: ModelFilterComingSoonBlockConfigType[];
    promotionBannerConfig?: ModelFilterPromotioBannerConfigType;
    pageUrlsModelData: NcPageUrlsModelDataType[];
    labels: Record<ModelFilterLabelType, string>;
    showETA: boolean;
};

export const initialStateModelFilterSettings: ModelFilterSettingsType = {
    initialized: false,
    fuelTypeSortOrder: [],
    newCarDisableMonthlySort: false,
    comingSoonBlockConfigurations: [],
    pageUrlsModelData: [],
    labels: { ...modelFilterLabels },
    showETA: false,
};

const ModelFilterSettingsReducer = (
    state: ModelFilterSettingsType = initialStateModelFilterSettings,
    action: ModelFilterSettingsActionsType,
): ModelFilterSettingsType => {
    switch (action.type) {
        case MODEL_FILTER_SETTINGS_INIT: {
            return { ...state, ...action.initState, initialized: true };
        }

        default:
            return state;
    }
};

export default ModelFilterSettingsReducer;
